// src/utils/api.js
import { logout } from './auth';

// Optional: If you still want to fetch a CSRF token, you can keep fetchCSRFToken() logic
// But you do NOT need to manually attach the JWT anymore.

async function fetchCSRFToken() {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/csrf/`, {
    credentials: 'include',  // to include cookies
  });
  if (response.ok) {
    const token = getCookie('csrftoken');
    console.log('CSRF Token:', token);
    return token;
  }
  throw new Error('Failed to fetch CSRF token');
}

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const apiCall = async (url, method = 'GET', body = null, headers = {}, requireCSRF = false) => {
  try {
    console.log(`Making ${method} request to: ${url}`);
    if (body) {
      // console.log('Request body (raw):', body); // Log raw body before potential stringification
    }
    
    let csrfToken = null;
    if (requireCSRF) {
      csrfToken = await fetchCSRFToken();
    }

    const managerToken = localStorage.getItem('managerToken');
    const authToken = localStorage.getItem('authToken'); 

    // Default headers. Will be conditionally changed for FormData.
    const combinedHeaders = {
      // Don't set Content-Type by default here, will be handled below
      ...(csrfToken && { 'X-CSRFToken': csrfToken }),
      ...headers,
    };

    if (managerToken) {
      combinedHeaders['Authorization'] = `Bearer ${managerToken}`;
    } else if (authToken) {
      // combinedHeaders['Authorization'] = `Bearer ${authToken}`;
    }

    const options = {
      method,
      headers: combinedHeaders,
      credentials: 'include',
    };

    // Handle body and Content-Type based on body type
    if (body && method !== 'GET' && method !== 'HEAD') {
      if (body instanceof FormData) {
        // For FormData, do NOT set Content-Type manually (browser does it)
        // and do NOT stringify the body.
        options.body = body;
        // Remove Content-Type if it was accidentally set by default or headers arg
        delete options.headers['Content-Type']; 
        console.log('Request body is FormData, sending as is.');
      } else {
        // For other body types (like JSON), set Content-Type and stringify.
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(body);
        // console.log('Request body (stringified for JSON):', options.body);
      }
    }

    // console.log('Final request options:', options);

    const response = await fetch(url, options);

    const contentType = response.headers.get('content-type');
    const responseText = await response.text();

    console.log('Response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers.entries()));
    console.log('Response text:', responseText);

    // If token is invalid or expired, the server might return 401 or 403
    // The custom ManagerJWTAuthentication now raises 401 specifically for auth issues
    if (response.status === 401) {
      // Optionally check if it's a manager URL before logging out manager?
      if (url.includes('/api/manager/')) {
          logout('manager'); // Assuming logout can handle different types or clears managerToken
          throw new Error('Manager Unauthorized (401) - Invalid/expired token or insufficient permissions. Logged out.');
      } else {
          logout('user'); // Assuming logout clears standard user token/session
          throw new Error('Unauthorized (401) - Possibly invalid/expired token. Logged out.');
      }
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}, message: ${responseText}`);
    }

    // If the response is JSON, parse it
    if (contentType && contentType.includes('application/json')) {
      try {
        const jsonResponse = JSON.parse(responseText);
        console.log('Parsed JSON response:', jsonResponse);
        return jsonResponse;
      } catch (parseError) {
        console.error('Error parsing JSON response:', parseError);
        return responseText; // fallback to raw text
      }
    } else {
      return responseText;
    }
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};

export default apiCall;
